import { all } from 'redux-saga/effects';
import authSaga from './auth.saga';
import grideableSaga from './grideable.saga';
import encargosSaga from './encargos.saga';
import driveSaga from './drive.saga';
import giotalkSaga from './giotalk.saga';
import pelSaga from './pel.saga';
import appSaga from './app.saga';
import coreSaga from './core.saga';
import articulosSaga from './articulos.saga';
import encargosCreador from './encargos.creador.saga';
import trazadoraSaga from './trazadora.saga';
import informesSaga from './informes.saga';
import newCoReposicionesSaga from './newCo.reposiciones.saga';
import pacientesSaga from './pacientes.saga';
import fichaOptometricaSaga from './fichaOptometrica.saga';
import fichaContactologicaSaga from './fichaContactologica.saga';
import cajaCreadorSaga from './caja.creador.saga';
import authenticationRequest from './caja.creador.saga';
import proveedoresSaga from './proveedores.saga';
import importarCatalogosPropios from './catalogosPropios.saga';
import pedidoslcWorkspaceSaga from './pedidoslc.saga';
import comerciaDatafonoSaga from "./comercia.datafono.saga";
import comerciaDatafonoWifiSaga from "./comercia.datafono.wifi.saga";


export default function* rootSaga() {
  yield all([
    authSaga(),
    grideableSaga(),
    encargosSaga(),
    driveSaga(),
    giotalkSaga(),
    pelSaga(),
    appSaga(),
    coreSaga(),
    articulosSaga(),
    encargosCreador(),
    trazadoraSaga(),
    informesSaga(),
    newCoReposicionesSaga(),
    pacientesSaga(),
    fichaOptometricaSaga(),
    cajaCreadorSaga(),
    authenticationRequest(),
    proveedoresSaga(),
    importarCatalogosPropios(),
    fichaContactologicaSaga(),
    pedidoslcWorkspaceSaga(),
    comerciaDatafonoSaga(),
    comerciaDatafonoWifiSaga(),
  ]);
}
